import { MaterialCommunityIcons } from '@expo/vector-icons';

import type { Icon } from './internal';

export const GenderMaleFemale: Icon = ({ color = '#000000', size = 24 }) => (
  <MaterialCommunityIcons name="gender-male-female" size={size} color={color} />
);
